module.exports = __webpack_public_path__ + "img/html.5f15aaf2.png";